import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../common/Header";
import $ from "jquery";
import useAuth from "../../../hooks/useAuth";
import Toastify from "../../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../../helpers/ServiceRequest";

function EditAgent() {
  const [agentData, setAgentData] = useState({});
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [salesPeople, setSalesPeople] = useState([
    {
      SalesName: "",
      Mobile: "",
      Current: "",
    },
  ]);

  const [errors, setErrors] = useState({});
  const [emailArray, setEmailArray] = useState([""])
  const [emailErrors, setEmailErrors] = useState({});

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  }, []);

  let navigate = useNavigate();
  const { id } = useParams();
  const { user } = useAuth();
  useEffect(() => {
    const fetchData = async () => {
      let URL = process.env.REACT_APP_API_URL + "/get-agent/" + id;
      let response = await GETREQUEST(URL, user.jwtToken);
      if (response?.data) {
        setSalesPeople(response.data.tblSalespeople);
        let data = response.data;
        let emailAddresses = data.EmailAddresses.split(",");

        delete data.tblSalespeople;
        delete data.EmailAddresses;

        setAgentData(data);
        setEmailArray(emailAddresses)
      }
    }

    fetchData();
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const addEmailRoom = () => {
    const lastEmail = emailArray[emailArray.length - 1];
    if (!validateEmail(lastEmail)) {
      setEmailErrors((prevErrors) => ({
        ...prevErrors,
        [emailArray.length - 1]: "Invalid email format",
      }));
      return;
    }

    setEmailArray((prevEmailArray) => [...prevEmailArray, ""]);
    setEmailErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[emailArray.length - 1];
      return newErrors;
    });

  }

  const updateEmail = (index, value) => {
    setEmailArray((prevEmailArray) =>
      prevEmailArray.map((email, i) => (i === index ? value : email))
    );
  }

  const checkEmail = (index, value) => {
    if (validateEmail(value)) {
      setEmailErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[index];
        return newErrors;
      });
    } else {
      setEmailErrors((prevErrors) => ({
        ...prevErrors,
        [index]: "Invalid email format",
      }));
    }
  }

  const handleDeleteEmail = (index) => {
    setEmailArray((prevEmailArray) =>
      prevEmailArray.filter((email, i) => { return i !== index })
    );
  }

  const checkErrors = async () => {
    let isError = false;
    const fields = ['AgentCode',
      "AgentDescription",
      "CompanyName",
      "WarehouseSort",
      "PrintSort"
    ]

    fields.map((field) => {
      let value = agentData[field];
      if (!value) {
        setErrors((prevData) => ({
          ...prevData,
          [field]: true
        }));
        isError = true;
      } else {
        setErrors((prevData) => {
          const updatedError = { ...prevData };
          delete updatedError[field];
          return updatedError;
        });
      }
    });

    return isError;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAgentData((prevData) => ({
      ...prevData,
      [name]: value
    }));

    if (Object.keys(errors).length > 0 && errors[name]) {
      setErrors((prevData) => {
        const updatedError = { ...prevData };
        delete updatedError[name];
        return updatedError;
      });
    }
  }

  const editAgent = async (e) => {
    e.preventDefault();
    const isError = await checkErrors();
    let URL = process.env.REACT_APP_API_URL + "/update-agent";


    if (Object.keys(errors).length > 0 || isError) {
      return false;
    }

    if (emailArray?.length === 1 && emailArray[0] == "") {
      setEmailErrors((prevErrors) => ({
        ...prevErrors,
        [0]: "Invalid email format",
      }));
      return false;
    }

    if (Object.keys(emailErrors).length > 0) {
      return false;
    }

    let payload = {
      ...agentData,
      EmailAddresses: emailArray.join(","),
      SalesPeople: salesPeople,
      Current: parseInt(agentData?.Current)
    };
    setMessage('');
    setMessageType('');
    let response = await POSTREQUEST(URL, payload, user.jwtToken);
    if (response?.data) {
      if (response.data.success) {
        setMessage(response.data.message);
        setMessageType('success');
        setTimeout(() => {
          navigate("/agents");
        }, 2000);
      } else {
        setMessage(response.data.message);
        setMessageType('error');
      }
    }
    else {
      setMessage(response?.error?.message || 'Failed to update Agent !!');
      setMessageType('error');
    }
  };

  const handleSalesChange = (index, event) => {
    const { name, value } = event.target;
    let salesP = [...salesPeople];
    if (name == "Current") {
      salesP[index] = { ...salesPeople[index], [name]: parseInt(value) };
    } else {
      salesP[index] = { ...salesPeople[index], [name]: value };
    }
    setSalesPeople(salesP);
  };
  const handleDelete = (index) => {
    let salesP = salesPeople.filter((a, i) => index !== i);
    setSalesPeople(salesP);
  };

  const renderSalesPeople = (el, i) => {
    return (
      <React.Fragment key={i}>
        {" "}
        <div className="spacer-2"></div>
        <div className="card p-4">
          <div className="card-header bg-white border-bottom-0">
            <h1 className="title-semibold fs-24 mb-1">Sales People</h1>
            {i != 0 && (
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: "15px",
                  padding: "10px",
                  cursor: "pointer",
                }}
                onClick={() => handleDelete(i)}
              >
                <i className="icon icon-delete fs-20"></i>
              </div>
            )}
          </div>
          <div className="card-body">
            <div className="cmb-15 row g-3">
              <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                Sales Person
              </label>
              <div className="col">
                <input
                  name="SalesName"
                  type="text"
                  className="form-control input-md"
                  placeholder="Enter sales Person"
                  onChange={(e) => handleSalesChange(i, e)}
                  defaultValue={el.SalesName || ""}
                />
              </div>
            </div>
            <div className="cmb-15 row g-3">
              <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                Mobile
              </label>
              <div className="col">
                <input
                  name="Mobile"
                  type="text"
                  className="form-control input-md"
                  placeholder="Enter mobile"
                  onChange={(e) => handleSalesChange(i, e)}
                  defaultValue={el.Mobile}
                />
              </div>
            </div>
            <div className="cmb-15 row g-3">
              <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                Status
              </label>
              <div className="col">
                <select
                  name="Current"
                  className="form-select input-md"
                  aria-label="Default select example"
                  onChange={(e) => handleSalesChange(i, e)}
                  value={el.Current}
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  const renderCrudDiv = () => {
    setSalesPeople([
      ...salesPeople,
      {
        SalesName: "",
        Mobile: "",
        Current: "",
      },
    ]);
  };
  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/agents"
                    className="text-decoration-none text-primary"
                  >
                    Agents
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Edit Agent
                </li>
              </ol>
            </nav>
          </div>
          <div className="row justify-content-center">
            <div className="width-xxl-35 width-xl-44 width-lg-60 width-md-80">
              <div className="card p-4">
                <div className="card-header bg-white border-bottom-0">
                  <h1 className="title-semibold fs-24 mb-1">Edit Agent</h1>
                  {/* <p className="text-lite fs-15 mb-0">
                    Please enter details to add new Agent
                  </p> */}
                </div>
                <form onSubmit={editAgent}>
                  <div className="card-body">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Agent Code
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md" +
                            (errors['AgentCode'] ? " is-invalid" : "")
                          }
                          placeholder="Enter agent code"
                          name="AgentCode"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          defaultValue={agentData?.AgentCode}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Agent Description
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md" +
                            (errors['AgentDescription'] ? " is-invalid" : "")
                          }
                          placeholder="Enter agent description"
                          name="AgentDescription"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          defaultValue={agentData?.AgentDescription}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Company Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md" +
                            (errors['CompanyName'] ? " is-invalid" : "")
                          }
                          placeholder="Enter company name"
                          name="CompanyName"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          defaultValue={agentData?.CompanyName}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Warehouse Sort
                      </label>
                      <div className="col">
                        {/* <input
                          type="text"
                          className={
                            "form-control input-md" +
                            (warehouseSortErr ? " is-invalid" : "")
                          }
                          placeholder="Enter warehouse sort"
                          onChange={(e) => {
                            setWarehouseSortErr(false);
                            setWarehouseSort(e.target.value);
                          }}
                        /> */}
                        <div className={`form-control d-flex justify-content-around ${errors['WarehouseSort'] ? " is-invalid" : ""}`}>
                          <div>
                            <label
                              className="form-check-label"
                              htmlFor="flexRadioDefault1"
                            >
                              A
                            </label>
                            <input
                              className="form-check-input cms-6"
                              type="radio"
                              name="WarehouseSort"
                              id="warehouseSortA"
                              value={"A"}
                              checked={agentData?.WarehouseSort == "A"}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                          <div>
                            <label
                              className="form-check-label cms-6"
                              htmlFor="flexRadioDefault1"
                            >
                              B
                            </label>
                            <input
                              className="form-check-input cms-6"
                              type="radio"
                              name="WarehouseSort"
                              id="warehouseSortB"
                              value={"B"}
                              checked={agentData?.WarehouseSort == "B"}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                          <div>
                            <label
                              className="form-check-label cms-6"
                              htmlFor="flexRadioDefault1"
                            >
                              C
                            </label>
                            <input
                              className="form-check-input cms-6"
                              type="radio"
                              name="WarehouseSort"
                              id="warehouseSortC"
                              value={"C"}
                              checked={agentData?.WarehouseSort == "C"}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                          <div>
                            <label
                              className="form-check-label cms-6"
                              htmlFor="flexRadioDefault1"
                            >
                              D
                            </label>
                            <input
                              className="form-check-input cms-6"
                              type="radio"
                              name="WarehouseSort"
                              id="warehouseSortD"
                              value={"D"}
                              checked={agentData?.WarehouseSort == "D"}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Print Sort
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md" +
                            (errors['PrintSort'] ? " is-invalid" : "")
                          }
                          placeholder="Enter print sort"
                          name="PrintSort"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          defaultValue={agentData?.PrintSort}
                        />
                      </div>
                    </div>
                    {emailArray?.map((email, index) => {
                      return (
                        <div className="cmb-15 row g-3 align-items-start">
                          <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                            {`Email ${index + 1}`}
                          </label>

                          <div className="col">
                            <div className="d-flex align-items-center">
                              <input type="email"
                                className={"form-control input-md"}
                                onChange={(e) => updateEmail(index, e.target.value)}
                                onBlur={(e) => checkEmail(index, e.target.value)}
                                placeholder={`Email ${index + 1}`}
                                value={email}
                              />
                              {index > 0 && <i style={{ cursor: "pointer" }} onClick={() => handleDeleteEmail(index)} className=" icon icon-delete ms-3 text-danger fw-bold"></i>}

                            </div>
                            {emailErrors[index] && (
                              <span style={{ color: "red", marginLeft: "10px" }}>
                                {emailErrors[index]}
                              </span>
                            )}
                          </div>
                          {/* <label><input type='checkbox' name="email_enable_flag" value={DNDEmail} checked={DNDEmail} onChange={(e)=> setDNDEmail(!DNDEmail)}></input>DND Email</label> */}
                        </div>
                      )
                    })}
                    <div className="cmb-15 row g-3 align-items-start">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">Add More Email</label>
                      <div className="col">
                        <button
                          className="btn btn-sm btn-secondary d-flex align-items-center text-nowrap px-3 fw-medium text-white rounded-3"
                          onClick={addEmailRoom}
                          type="button"
                        >
                          <i className="icon icon-add cpe-5 fs-13"></i> Add Email
                        </button>
                      </div>
                    </div>

                    <div className="cmb-15 row g-3 align-items-start">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">Enable Email</label>
                      <div className="col">
                        <input type='checkbox' className="m-1" name="DNDEmail" value={agentData?.DNDEmail} checked={agentData?.DNDEmail ? true : false} onChange={(e) => {
                          e.target = {
                            name: e.target.name, value: e.target.checked ? 1 : 0
                          }
                          handleChange(e);

                        }} />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Status
                      </label>
                      <div className="col">
                        <select
                          className={"form-select input-md"}
                          aria-label="Default select example"
                          onChange={(e) => { handleChange(e) }}
                          name="Current"
                          value={agentData?.Current}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {salesPeople.map((el, i) => {
                    return renderSalesPeople(el, i);
                  })}
                  <div className="spacer-2"></div>
                  <button
                    className="btn btn-sm btn-secondary d-flex align-items-center text-nowrap px-3 fw-medium text-white rounded-3"
                    onClick={renderCrudDiv}
                    type="button"
                  >
                    <i className="icon icon-add cpe-5 fs-13"></i> Add sales
                    people
                  </button>

                  <div className="card-footer bg-white d-flex border-top-0">
                    <div className="d-grid w-100">
                      <button
                        type="submit"
                        className="btn btn-secondary btn-form text-white d-flex align-items-center justify-content-center px-4 fw-medium rounded-3"
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
export default EditAgent;
